export const INVALID_REFERENCE_NUMBER = "Please enter a valid reference number";
export const INVALID_POSTCODE = "Please enter a valid postcode";
export const INVALID_PHONE = "Please enter a valid phone number";
export const INVALID_EMAIL = "Please enter a valid email";
export const CONTACT_NAME_REQUIRED = "Contact Name is required";
export const REQUIRED_FIELD = "Please fill in this field";
export const FIELD_VALUE_TOO_LONG = "Field value too long";
export const INVALID_CONTACT_NUMBER = "Please enter a UK mobile/phone number";